<script setup lang="ts">
import { ref } from 'vue';
import GroupsList from './groups-list.vue';
import GroupPatientsTab from './group-patients-tab.vue';
import GroupCaregiversTab from './group-caregivers-tab.vue';

const activeTab = ref<'groups' | 'patients' | 'caregivers'>('groups');
</script>

<template>
  <v-card>
    <v-card-title class="font-weight-bold pa-6 pb-2">
      Grupos
    </v-card-title>
    <v-tabs
      v-model="activeTab"
      color="primary"
      align-tabs="start"
      class="px-4 mb-2"
    >
      <v-tab value="groups">
        <v-icon
          start
          icon="mdi-account-group"
        />
        Grupos
      </v-tab>
      <v-tab value="patients">
        <v-icon
          start
          icon="mdi-account-multiple"
        />
        Pacientes
      </v-tab>
      <v-tab value="caregivers">
        <v-icon
          start
          icon="mdi-stethoscope"
        />
        Profesionales
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-card-text class="pa-4">
      <groups-list v-if="activeTab === 'groups'" />
      <group-patients-tab v-else-if="activeTab === 'patients'" />
      <group-caregivers-tab v-else />
    </v-card-text>
  </v-card>
</template>
